import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getHostDetails } from "../store/thunks/HostActions";
import EntryInstructionsEmailSettings from "../components/hostComponents/EntryInstructionsEmailSettings";

function HostEntryInstructionsSettings() {
  const { hid } = useParams();
  const dispatch = useDispatch();
  const { host, loading, error } = useSelector((state) => state.hostDetails);
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    if (hid) {
      dispatch(getHostDetails(hid));
    }
  }, [dispatch, hid]);

  const infoRow = (label, value) => (
    <div className="flex flex-col">
      <span className="text-xs font-semibold text-zinc-500 uppercase tracking-wide">{label}</span>
      <span className="text-sm text-zinc-900">{value || "—"}</span>
    </div>
  );

  return (
    <div className="p-6 space-y-4">
      <h1 className="text-2xl font-bold text-zinc-900">Host Entry Instructions Settings</h1>

      {loading && (
        <div className="p-4 rounded-lg border border-zinc-200 bg-white shadow-sm">
          <p className="text-sm text-zinc-600">Loading host details...</p>
        </div>
      )}

      {error && (
        <div className="p-4 rounded-lg border border-red-200 bg-red-50 text-red-700 text-sm">
          Failed to load host: {error}
        </div>
      )}

      {!loading && !error && host && (
        <>
          <div className="p-4 rounded-lg border border-zinc-200 bg-white shadow-sm space-y-3">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {infoRow("First Name", host.firstName)}
              {infoRow("Last Name", host.lastName)}
              {infoRow("Company", host.company)}
              {infoRow("Internal Notes", host.internalHostNotes)}
            </div>
          </div>

          <EntryInstructionsEmailSettings
            host={host}
            setSuccessMessage={setSuccessMessage}
            setErrorMessage={setErrorMessage}
          />

          {(successMessage || errorMessage) && (
            <div className="p-3 rounded-lg border text-sm"
              style={{
                borderColor: successMessage ? "#bbf7d0" : "#fecdd3",
                background: successMessage ? "#f0fdf4" : "#fff1f2",
                color: successMessage ? "#166534" : "#9f1239",
              }}
            >
              {successMessage || errorMessage}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default HostEntryInstructionsSettings;





